import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';
import { OperationService } from '../operations/operation/operation.service';
import { Injectable } from '@angular/core';
import { DbContext, DbTable } from '../data/dbcontext.service';
import { DateService } from '../date/date.service';
import { HttpClient } from '@angular/common/http';
import { DailyOperationLogRecord, DailyOperationLogRecordHelper } from '../../models/projects/operation.models';
import { DailyLogService } from '../daily-log/daily-log.service';
import { AppDataSyncService } from '../app-data-sync/app-data-sync.service';
import { TimeZoneService } from '../time-zone/time-zone.service';
import { AppConfig } from '../../app/app.config';

@Injectable()
export class CommentsService {

  config = AppConfig.settings;

  private readonly dailyLogTable: DbTable;
  private readonly millisecondsInDay = 86400000;

  constructor(
    private http: HttpClient,
    private dbContext: DbContext,
    public dateParserService: DateParserService,
    public dailyLogService: DailyLogService,
    public dateService: DateService,
    public operationService: OperationService,
    public appDataSyncService: AppDataSyncService,
    private timeZoneService: TimeZoneService
  ) {
    this.dailyLogTable = this.dbContext.tables.find(t => t.name === 'DailyLogData');
  }

  async createCommentLogEntry(
    record: DailyOperationLogRecord,
    id: number
  ): Promise<DailyOperationLogRecordHelper> {
    const helper = new DailyOperationLogRecordHelper();
    helper.records = [];
    let sortTime = null;
    let endTime = null;

    if (!!record.endTimeShow) {
      endTime = record.endTime;
      // todo - check needed
      // endTime.date = new Date(record.endTime.date.getTime() - record.endTime.date.getTimezoneOffset() * 60000);
      sortTime = endTime.dateTime;
    }

    let startTime = null;
    if (record.startTimeShow) {
      startTime = record.startTime;
      // add offset to start time before sending to api
      // todo - check needed
      // startTime.date = new Date(record.startTime.date.getTime() - record.startTime.date.getTimezoneOffset() * 60000);
      sortTime = startTime.dateTime;
    }

    record.sortTime = sortTime;
    record.startTime = startTime;
    record.endTime = endTime;
    record.localId = id;

    if (record.startTime) {
      record.startTimeOffset = record.startTimeOffset ? record.startTimeOffset : await this.timeZoneService.offsetForTime(record.startTime.dateTime);
    }
    if (record.endTime) {
      record.endTimeOffset = record.endTimeOffset ? record.endTimeOffset : await this.timeZoneService.offsetForTime(record.endTime.dateTime);
    }

    await this.dateParserService.deserializeDates(record);

    await this.operationService.getDailyLogRecordUniqueOrdinal(1).then(uniqueOrdinal => {
      record.uniqueOrdinal = uniqueOrdinal;
      this.dailyLogService.saveDailyLogRecord(id, record);
      helper.records.push(record);
    });

    return helper;
  }
}



// WEBPACK FOOTER //
// ./src/services/comments/comments.service.ts